import React, { useContext, useEffect, useRef, useState } from 'react';
import { ArrowLeft, Link } from 'react-bootstrap-icons';
import { NavLink } from 'react-router-dom';
import FlattenedHash from '../../../../libs/templating/FlattenedHash';
import CommonFunctionsContext from '../../../common/CommonFunctionsProvider';
import DashboardContext from './DashboardProvider';
const animateCSSTransition = (element, animation, element2, animation2, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const animationName2 = `${prefix}${animation2}`;
        // const node = document.querySelector(element);
        if (!(element && element2)) {
            resolve('Animation ended');
            return
        }
        const node = element;
        const node2 = element2;
        node.classList.remove(`d-none`);
        node.classList.add(`${prefix}animated`, animationName);
        node.classList.add(`animate__faster`);
        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation();
            node.classList.remove(`${prefix}animated`, animationName);
            node.classList.add(`d-none`);
            node2.classList.remove(`d-none`);
            node2.classList.add(`animate__faster`);
            node2.classList.add(`${prefix}animated`, animationName2);

            // node.classList.add(`d-none`);
            resolve('Animation ended');
        }


        node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });
export default function DashboardCardContainer({ title, icon, tail, breakdown, details, children }) {
    const { GlobalRef, helpRefs } = useContext(CommonFunctionsContext)
    const { setFilter } = useContext(DashboardContext)
    const [active, setActive] = useState()
    const initialized = useRef(false)
    useEffect(() => {
        if (initialized.current) {
            if (typeof active === 'undefined') {
                setFilter(breakdown.properties.module, breakdown.properties.filter, undefined)
                animateCSSTransition(helpRefs.current[`${title}Group`].current, 'fadeOutUp', helpRefs.current[`${title}GroupBreakDown`].current, 'fadeInRight')
            } else {
                setFilter(breakdown.properties.module, breakdown.properties.filter, active.value)
                animateCSSTransition(helpRefs.current[`${title}GroupBreakDown`].current, 'fadeOutUp', helpRefs.current[`${title}Group`].current, 'fadeInRight')
            }
        }
        initialized.current = true
    }, [active])

    return (
        <div className='col-lg-4 col-md-12 dashboard-card' style={{ maxHeight: 'calc(50% - 0.5rem)', height: 'calc(50% - 0.5rem)' }}>
            <div className='text-center bg-secondary-container p-3 rounded h-100 d-flex flex-column'>
                <DashboardCardTitle title={title} icon={icon} />
                <div style={{ overflowY: 'auto', overflowX: 'hidden' }} className='flex-grow-1 d-flex flex-column justify-content-start align-items-start '>
                    <DashboardCardNotice title={title} />
                    <div className='d-flex flex-grow-1 w-100 flex-column ' ref={r => GlobalRef(r, `${title}GroupBreakDown`)}>
                        {/* {breakdown && breakdown.options.map(b => <DashboardCardBreakdown title={title} detail={b} setActive={setActive} />)} */}
                        {breakdown && <DashboardCardBreakdown title={title} breakdown={breakdown} setActive={setActive} />}
                    </div>
                    <div style={{ overflow: 'hidden' }} className='d-none flex-grow-1 w-100 flex-column' ref={r => GlobalRef(r, `${title}Group`)}>
                        <div className='d-flex flex-column h-100'>
                            <div className='d-flex flex-column flex-shrink-1 bg-primary-section'>
                                <DashboardCardDetailsTitleBar setActive={setActive} title={title} active={active && active} />
                            </div>
                            <div className=' flex-grow-1' style={{ overflow: 'auto', height: '100%', maxHeight: '100%' }}>
                                <DashboardCardDetails details={details} module={breakdown.properties.module} />
                            </div>
                        </div>

                    </div>
                    {/* {results && results.messages && results.messages.dailyBreakDown && <MessageDashboardNewMessageLineItemGroups active={active} setActive={setActive} counts={results.messages.dailyBreakDown} />} */}
                </div>
                <DashboardCardTail items={tail} />
            </div>
        </div>
    )
}

const DashboardCardNotice = ({ title }) => {
    const { GlobalRef } = useContext(CommonFunctionsContext)
    return (<div ref={r => GlobalRef(r, `${title}Notice`)} className='d-none align-self-center'></div>)
}
const DashboardCardBreakdown = ({ title, breakdown, setActive }) => {
    const [status, setStatus] = useState([])
    const { results } = useContext(DashboardContext)
    useEffect(() => {
        try {
            if (results)
                if (results && Object.keys(results).includes(breakdown.properties.module) && results[breakdown.properties.module][breakdown.properties.key]) {
                    if (Array.isArray(results[breakdown.properties.module][breakdown.properties.key])) {
                        var _status = []
                        var cnt = 0
                        for (const res of results[breakdown.properties.module][breakdown.properties.key]) {
                            const Flatten = new FlattenedHash(res, breakdown.properties.module, {
                                //     // 'Assignment|status|dateTimeCreated': (s) => { return DateTimePickerFunctions.FancyHumanDT(new Date(s)) },
                                //     // 'Message|receviedDate': (s) => { return DateTimePickerFunctions.LocalISO(new Date(s), 'h') }
                            })
                            _status[cnt++] = Flatten.FromMustache(breakdown.properties.template)
                        }
                        setStatus(_status)
                    }
                }
        } catch (e) {
            console.error(`Failed to parse template for ${title} ${e.message}`)
        }
    }, [results])
    return (breakdown.options && breakdown.options.map((b, i) => <DashboardCardBreakdownItem properties={breakdown.properties} status={status.length >= i ? status[i] : ''} detail={b} setActive={setActive} />))
}
const DashboardCardBreakdownItem = ({ status, detail, setActive }) =>
    <button className='text-start d-flex w-100 btn mb-1 shadow ' onClick={e => setActive({ ...detail })}>
        <div className='flex-grow-1 align-items-start'>{detail.icon} {detail.name}</div>
        <div className='d-flex justify-content-end' dangerouslySetInnerHTML={{ __html: status }} />
    </button>

const DashboardCardDetailsTitleBar = ({ setActive, title, active }) => {
    const { Queue } = useContext(DashboardContext)
    return (<div className='d-flex align-items-center'>
        <button className='btn btn-sm  bg-primary-button' onClick={e => setActive()}><ArrowLeft /> </button>
        <div className='flex-grow-1 align-self-center'>{`${title} for ${active ? active.name : ''}`}</div>

    </div>)
}
const DashboardCardDetails = ({ details, module }) => {
    const { results } = useContext(DashboardContext)
    return ({
        ...details.component,
        props: {
            ...details.component.props,
            results: results[module]
        }
    })
}
const DashboardCardTitle = ({ title, icon }) =>
    <div className='flex-shrink-1'>
        <h3>{icon}{title}</h3>
    </div>

const DashboardCardTail = ({ items }) => items && items.map(item =>
    <NavLink key={`nav-${item.description}`} className={"btn btn-sm"} tag={Link} to={item.to} >
        <button className='btn btn-sm'>{item.icon}{item.description}</button>
    </NavLink>)